import React from "react";

import Manufacturer from "components/Tvendo/Article/DataMaster/Manufacturer/List.js";

export default function () {
  return <Manufacturer />;
}
